import { useQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import GET_MY_WISH_LIST from '../operations/queries/get-my-wish-list.js';
import { mapShoppingListToWishlistItems } from '../utils/shopping-list-to-wishlist-mapper.js';

const useGetMyWishList = ()=>{
    var ref, ref1, ref2, ref3;
    const { locale  } = useIntl();
    const { data , loading , error  } = useQuery(GET_MY_WISH_LIST, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    var ref4;
    return {
        data: (data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : ref.wishlist) ? {
            items: mapShoppingListToWishlistItems(data === null || data === void 0 ? void 0 : (ref1 = data.me) === null || ref1 === void 0 ? void 0 : ref1.wishlist),
            id: (ref4 = data === null || data === void 0 ? void 0 : (ref2 = data.me) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.wishlist) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref4 !== void 0 ? ref4 : ''
        } : null,
        loading,
        error: error || null
    };
};

export { useGetMyWishList };
//# sourceMappingURL=use-get-my-wish-list.js.map
